import { Component, Input } from '@angular/core';
import { UiBadgeVariant } from '../../models/ui-badge.model';

@Component({
  selector: 'app-ui-badge',
  templateUrl: './ui-badge.component.html',
  styleUrls: ['./ui-badge.component.scss']
})
export class UiBadgeComponent {
  @Input() label = '';
  @Input() variant: UiBadgeVariant = 'default';
  @Input() showDot = true;
}
